export const PATCH_LIST = 'PATCH_LIST';
export const PATCH_LIST_SUCCESS = 'PATCH_LIST_SUCCESS';
export const PATCH_LIST_ERROR = 'PATCH_LIST_ERROR';

export const PATCH_DETAILS = 'PATCH_DETAILS';

export const PATCH_INSPECTION_LIST = 'PATCH_INSPECTION_LIST';
export const PATCH_INSPECTION_LIST_SUCCESS = 'PATCH_INSPECTION_LIST_SUCCESS';
export const PATCH_INSPECTION_LIST_ERROR = 'PATCH_INSPECTION_LIST_ERROR';
